// extracted by mini-css-extract-plugin
export default {"dlUploadBox":"src-js-containers-upload-components-UploadBox---dlUploadBox---Hjqef"};